import React from "react";

const terms = [
  {
    title: "Acceptance of Terms",
    description: "By accessing or using SailorsData.com, you agree to comply with and be bound by these Terms of Service. If you do not agree, you must discontinue use of the platform.",
  },
  {
    title: "Services Provided",
    description: "SailorsData offers recruitment and career services for maritime, offshore, and oil & gas industries. Employers can post jobs, manage applications, and connect with candidates. Job seekers can create profiles, upload CVs, and apply for opportunities.",
  },
  {
    title: "User Responsibilities",
    description: "",
    subpoints: [
      "Accuracy of Information: Users must provide truthful and up-to-date information.",
      "Account Security: You are responsible for maintaining the confidentiality of your login credentials.",
      "Lawful Use: You agree not to misuse the platform for fraudulent, illegal, or harmful activities.",
    ],
  },
  {
    title: "Employer Obligations",
    description: "Employers must ensure job postings are genuine, non-discriminatory, and comply with applicable labor laws.",
  },
  {
    title: "Intellectual Property",
    description: "All content, branding, and design elements on SailorsData.com are the property of SailorsData and may not be copied or reused without permission.",
  },
  {
    title: "Limitation of Liability",
    description: "SailorsData acts as a platform to connect employers and job seekers. We do not guarantee employment, nor are we responsible for any agreements made between parties outside the platform.",
  },
  {
    title: "Termination",
    description: "SailorsData reserves the right to suspend or terminate accounts that violate these Terms.",
  },
  {
    title: "Governing Law",
    description: "These Terms are governed by the laws of India, with jurisdiction in Bhubaneswar, Odisha.",
  },
];

function TermsOfServicePage() {

  return (
    <>
      <section id="terms" className="contact section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Terms of Service</h2>
        </div>

        <div className="container" data-aos="fade" data-aos-delay="100">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              {terms.map((term, idx) => (
                <div key={idx} className="mb-4">
                  <h5 className="mb-2">{idx + 1}. {term.title}</h5>
                  {term.description && <p className="text-secondary">{term.description}</p>}
                  {term.subpoints && (
                    <ul className="list-unstyled ms-3">
                      {term.subpoints.map((point, i) => (
                        <li key={i} className="mb-1">
                          <i className="bi bi-dot me-2 text-primary"></i>
                          {point}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default TermsOfServicePage;
